<template>
  <dialog-modal-fi
    ref="dialogModal"
    class="cad-details-dialog-fi"
    prevent-close-on-click-outside
    only-body-scrollable
  >
    <template #body>
      <iframe
        v-if="cadUrl"
        ref="cadFrame"
        :src="cadUrl"
        :title="dict.get('product-Catalog.Block-Labels.Technical-Data.CAD-Data')"
        allow="clipboard-read; clipboard-write"
        class="cad-details-dialog-fi__iframe"
      />
    </template>

    <template #button>
      <icon-fi icon="close" />
    </template>
  </dialog-modal-fi>
</template>

<script setup lang="ts">
import { DialogModalFi, IconFi } from 'atoms';
import { useTemplateRef } from 'vue';

import { useDict } from '@/composables/fischerPlugin';

interface Props {
  cadUrl?: string | null;
}

defineOptions({
  name: 'CadDetailsDialogFi',
});

withDefaults(defineProps<Props>(), {
  cadUrl: null,
});

const dict = useDict();

const dialogModal = useTemplateRef('dialogModal');

const open = () => {
  dialogModal.value?.open();
};

defineExpose({
  open,
});
</script>

<style src="./cad-details-dialog-fi" />
